import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faShieldAlt, 
  faClock,
  faUsers,
  faFileShield,
  faGem,
  faIndustry,
  faRocket
} from '@fortawesome/free-solid-svg-icons';
import '../../styles/components/dashboard/LandingPage.css';

function LandingPage({ user }) {
  const [currentTime, setCurrentTime] = useState(new Date());
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (date) => {
    return date.toLocaleTimeString('es-CL', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const formatDate = (date) => {
    return date.toLocaleDateString('es-CL', {
      weekday: 'long',
      day: 'numeric',
      month: 'long'
    });
  };

  const quickActions = user?.rol === 'admin' ? [
    {
      icon: faUsers,
      title: "Gestionar Usuarios",
      path: "/usuarios"
    },
    {
      icon: faGem,
      title: "Gestionar Certificados",
      path: "/certificados"
    },
    // {
    //   icon: faShieldAlt,
    //   title: "Métricas del Sistema",
    //   path: "/metricas"
    // }
  ] : [
    {
      icon: faFileShield,
      title: "Mis Certificados",
      path: "/historial"
    }
  ];

  return (
    <div className="landing-simple">
      {/* Header Simplificado */}
      <div className="header-simple">
        <div className="welcome-info">
          <img 
            src="/logos/logo-navbar.png" 
            alt="Logo" 
            className="logo-simple"
            onError={(e) => e.target.style.display = 'none'}
          />
          <div className="welcome-text">
            <h1>Bienvenido{user?.rol === 'admin' ? ' Administrador' : ''}, {user?.nombre}</h1>
            <p>{user?.empresa}</p>
          </div>
        </div>
        
        <div className="time-simple">
          <FontAwesomeIcon icon={faClock} />
          <div>
            <div className="time-value">{formatTime(currentTime)}</div>
            <div className="date-value">{formatDate(currentTime)}</div>
          </div>
        </div>
      </div>

      {/* Acciones Compactas */}
      <div className="actions-simple">
        {quickActions.map((action, index) => (
          <button
            key={index}
            type="button"
            className="action-simple"
            onClick={() => navigate(action.path)}
          >
            <FontAwesomeIcon icon={action.icon} className="action-icon-simple" />
            <span>{action.title}</span>
          </button>
        ))}
      </div>

      {/* Stats Mínimas */}
      <div className="stats-simple">
        <div className="stat-simple">
          <FontAwesomeIcon icon={faGem} />
          <div>
            <div className="stat-number">500+</div>
            <div className="stat-label">Equipos</div>
          </div>
        </div>
        <div className="stat-simple">
          <FontAwesomeIcon icon={faShieldAlt} />
          <div>
            <div className="stat-number">10K+</div>
            <div className="stat-label">Certificados</div>
          </div>
        </div>
        <div className="stat-simple">
          <FontAwesomeIcon icon={faIndustry} />
          <div>
            <div className="stat-number">99.9%</div>
            <div className="stat-label">Confiabilidad</div>
          </div>
        </div>
      </div>

      {/* Footer Mínimo */}
      <div className="footer-simple">
        <span>Andes Mining Solutions</span>
        <div className="status-simple">
          <FontAwesomeIcon icon={faRocket} />
          <span>Operativo</span>
        </div>
      </div>
    </div>
  );
}

export default LandingPage;